import { useEffect } from 'react'
import DecodeButtonComponent from './DecodeButtonComponent'

function addScript(src, callback) {
    var script = document.createElement('script')
    script.src = src
    script.type = 'text/javascript'
    document.head.appendChild(script)
    if (typeof callback == 'function') {
        setTimeout(() => {
            callback()
        }, 100)
    }
}
function addStyleSheet(href) {
    var link = document.createElement('link')
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = href
    document.head.appendChild(link)
}

const TranskeyComponent = () => {
    useEffect(() => {
        addStyleSheet('/transkey_mobile/transkey.css')
        /*
            transkey 4.6.15.2 transkey_config.js 분리되어 스크립트 로드 순서 문제가 있음
            script 로드시 transkey_surl is not defined 방지 예방
            transkey_config.js -> transkey.js 로드 되도록 설정이 필요함 
        */
        addScript('/transkey_mobile/transkey_mobile_config.js', () => {
            console.log('transkey_mobile_config.js Loaded')
            addScript('/transkey_mobile/transkey.js', () => {
                console.log('transkey.js Loaded')
                window.tk_useTranskey = true

                if (
                    typeof window.useSession == 'boolean' &&
                    typeof TK_requestToken == 'number' &&
                    typeof window.setMaxDigits == 'function' &&
                    typeof window.SecureRandom == 'function'
                ) {
                    window.initmTranskey()
                } else {
                    setTimeout(() => {
                        console.error('network is slow enviroment')
                        window.initmTranskey()
                    }, 2000)
                }
            })
        })
    }, [])

    return (
        <>
            <h1>TranskeyComponent.js</h1>

            <input
                type="text"
                id="pin0"
                name="pin0"
                data-tk-nextsibling="true"
                data-tk-kbdtype="number"
                data-tk-bottom="true"
                onFocus={(e) => {
                    window.mtk.onKeyboard(e.target)
                }}
                placeholder="비밀번호1"
                onChange={(e) => {
                    console.log('change')
                }}
            />
            <input
                type="text"
                id="pin1"
                name="pin1"
                data-tk-nextsibling="true"
                data-tk-kbdtype="number"
                data-tk-bottom="true"
                onFocus={(e) => {
                    window.mtk.onKeyboard(e.target)
                }}
                placeholder="비밀번호2"
                onChange={(e) => {
                    console.log('change')
                }}
            />
            <DecodeButtonComponent props={{ id0: 'pin0', id1: 'pin1' }} />
        </>
    )
}
export default TranskeyComponent
